// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oFlNzEfQHCATwBKdzE0z{padding:12px}.WpxCcUNw85o0cXALJN79{border:none;padding:0}.KfHCHMp3vgSzt2Z_HLua{margin-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapDropdown": `oFlNzEfQHCATwBKdzE0z`,
	"calendarClassName": `WpxCcUNw85o0cXALJN79`,
	"wrapInputsClassName": `KfHCHMp3vgSzt2Z_HLua`
};
export default ___CSS_LOADER_EXPORT___;
